import { useNavigate, useParams } from "react-router";
import { Button } from "@/components/ui/button";
import { EmptyState } from "@/components/shared/empty-state";
import { ROUTES } from "@/app/routes";
import { useDocumentTitle } from "@/lib/hooks/use-document-title";
import { useTenantContext } from "@/lib/hooks/use-tenant-context";
import { useAuth } from "@/features/auth/auth-provider";
import { AdminUserSessionWorkspace } from "./admin-user-session-workspace";

export function AdminConversationsPage() {
  const { isPlatformAdmin } = useAuth();
  const { tenantId } = useTenantContext();
  const { userId } = useParams<{ userId: string }>();
  const navigate = useNavigate();
  useDocumentTitle("Admin Conversations");

  if (!isPlatformAdmin) {
    return (
      <EmptyState
        title="Admin access required"
        description="Only platform admins can open filtered conversations for another user."
      />
    );
  }

  if (!userId) {
    return (
      <EmptyState
        title="User not selected"
        description="Pick a user before opening admin conversations."
        action={{
          label: "Choose user",
          onClick: () => navigate(ROUTES.tenantAdminConversationsUsers(tenantId)),
        }}
      />
    );
  }

  return (
    <div className="grid gap-3">
      <div className="flex items-center justify-between">
        <div>
          <h2 className="text-sm font-semibold" style={{ color: "var(--text-strong)" }}>
            Admin Conversations
          </h2>
          <p className="text-xs" style={{ color: "var(--muted-foreground)" }}>
            Viewing sessions as user {userId}
          </p>
        </div>
        <Button
          variant="outline"
          onClick={() => navigate(ROUTES.tenantAdminConversationsUsers(tenantId))}
        >
          Change User
        </Button>
      </div>
      <AdminUserSessionWorkspace targetUserId={userId} />
    </div>
  );
}
